
export default {

	props: {
		card: {
			type: Object,
			required: true
		},

		ticketTypes: Array,
		seatName: String,
	},

	data() {
		return {
			changed_default: true,
			selected_card: undefined,
			isDisabled: true
		}
	},

	watch: {
		selected_card() {
			if(this.selected_card != undefined) {
				this.card.type = this.selected_card.TicketTypeCode
			} else {
				this.card.type = undefined
			}

			this.selected_card != undefined && this.card.number != '' ? this.isDisabled = false : this.isDisabled = true
		},

		'card.number' () {
			if (this.selected_card != undefined && this.card.number != '') {
				this.isDisabled = false
			} else {
				this.isDisabled = true
			}
		}
	},

	methods: {
		editCard() {
			this.card.valid = false
			this.$parent.$parent.newCard = true
		},

		deleteCard() {
			this.$parent.$parent.deleteCard(this.card)
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/booking/loyalty/loyalty-card.js